import React, { useContext, useEffect, useState } from 'react'
import { LuUpload } from 'react-icons/lu';
import { BsFiletypePdf, BsImageFill } from 'react-icons/bs';
import PartnerContext from '../../hooks/PartnerContext';
import { useNavigate } from 'react-router-dom';
import { IoSearchOutline } from 'react-icons/io5';
import { IoInformationCircleSharp } from "react-icons/io5";
import { Tooltip } from "react-tooltip";
import { MdDelete } from 'react-icons/md';
import { IoIosInformationCircleOutline } from 'react-icons/io';




const PartnerHomeAndReview = () => {

    const { review,
        getDraftData,
        redirectPage,
        selectedCard,
        selectedTemplateCard,
        setSelectedTemplateCard,
        imageData,
        setImageData,
        imageBlob,
        setImageBlob,
        pdfBlob,
        setPdfBlob,
        pdfData,
        setPdfData,
        partnerHomeDatas,
        setPartnerHomeDatas,
        handleTitle,
        handleDetailedDescription,
        handleLink,
        handleReviewButton,
        handleBackButton,
        handlePostAd,
        handleDraftPost,
        handleUpdateAd,
        getRootPropsImage,
        getInputPropsImage,
        isDragActiveImage,
        getRootPropsPdf,
        getInputPropsPdf,
        isDragActivePdf,

        // First Page
        handleCreateNewCard,
        pageNumber,
        draftLoading,
        handleNewOrDraftPost,
        createNewAd,
        setCreateNewAd,
        existingAd,
        setExistingAd,
        jobAdStatus,
        setDraftId,
        updateButton,
        postDraftButton,
        setImageUrlToBlob,
        setPdfUrlToBlob,
        postAdLoading,
        setImageStatus,
        adNotLeft,setAdNotLeft,
        handleAdfNotLeftModalButton
    } = useContext(PartnerContext);

    const pageRender = useNavigate();

    const [getDraftDataDuplicates, setGetDraftDataDuplicates] = useState([]);

    useEffect(() => {
        setGetDraftDataDuplicates(getDraftData)
    }, [getDraftData])

    useEffect(() => {
        if (existingAd === true) {

            var updateReviewDatas = {
                ...partnerHomeDatas,
                id: createNewAd.learning_id,
                title: createNewAd.title,
                detailedDescription: createNewAd.detailed_description,
                link: createNewAd.url,
                image: createNewAd.image,
                pdf: createNewAd.attached_file
            }
            
            var pdfSplit = createNewAd.attached_file.split('/')
            if (pdfSplit[2] !== '') {
                setPdfData([pdfSplit[2]])
            }
            else {
                setPdfData([])
                setPdfBlob({})
            }


            var imageSplit = createNewAd.image.split('/')
            if (imageSplit[2] !== '') {
                setImageData([imageSplit[2]])
            }
            else {
                setImageBlob({})
                setImageData([])
            }
            

            setPartnerHomeDatas(updateReviewDatas);
        }
        else {
            setPartnerHomeDatas({
                id: "",
                title: "",
                detailedDescription: "",
                link: "",
                image: "",
                pdf: ""
            })
            setPdfBlob({})
            setImageBlob({})
        }
    }, [existingAd])


    const handleSearchGetAd = (e) => {
        var filterSearchResults = getDraftData.filter((v) => {
            return v.title.toLowerCase().includes(e.target.value.toLowerCase())
        })

        setGetDraftDataDuplicates(filterSearchResults)
    }


    const handleDraftTemplate = (e, value) => {
        setSelectedTemplateCard(true)
        setExistingAd(true)
        setCreateNewAd(value)
        setDraftId(value.id)

        setImageBlob({})
        setPdfBlob({})


        var imgg = value.image
        var splitBySlash = imgg.split("/")
        var splitByDot = imgg.split(".")
        if (splitBySlash[2] !== '') {
            fetch(`https://cdn.2ndcareers.com/${value.image}`)
                .then((res) => res.blob())
                .then(blob => {
                    const imgfile = new File([blob], splitBySlash[splitBySlash.length - 1], { type: `image/${splitByDot[splitByDot.length - 1]}` })
                    setImageUrlToBlob(imgfile)
                })
        }
        else {
            setImageUrlToBlob({})
            setImageData([])
        }

        



        var attached_file = value.attached_file
        var splitPdfBySlash = attached_file.split("/")
        var splitPdfByDot = attached_file.split(".")
        if (splitPdfBySlash[2] !== '') {
            fetch(`https://cdn.2ndcareers.com/${value.attached_file}`)
                .then((res) => res.blob())
                .then(blob => {
                    const file = new File([blob], splitPdfBySlash[splitPdfBySlash.length - 1], { type: `application/${splitPdfByDot[splitPdfByDot.length - 1]}` })

                    setPdfUrlToBlob(file)
                })
        }
        else {
            setPdfUrlToBlob({})
            setPdfData([])
        }
    }

    // create a new `Date` object
    var now = new Date();
    var currentDateTime = now.toLocaleString('en-US', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' });

    

    const handleAdNotLeftRedirect = () => {
        document.getElementById("adNotLeftCloseButton").click()
        pageRender("/partner_dashboard/home")
    }



    return (
        <>
            {/* First Page */}
            <div className={pageNumber === true ? "d-block" : "d-none"}>
                <div className="container-fluid community-page-bg min-vh-100 pt-4">
                    <div className='row row-cols-12'>
                        <div className="card col-11 col-md-9 col-lg-8 col-sm-10 mx-auto border-0 shadow-sm rounded-4 py-4 employerHomePadding">
                            <div className="card px-3 cursorPointer" id='postANewAd' onClick={() => document.getElementById('startNewCard').click()}>
                                <div className="card-body">
                                    <div className='d-flex align-items-center'>
                                        <div className="form-check me-4">
                                            <input className="form-check-input yesOrNoRadioButtonColor" type="radio" name="wayToPost" id="startNewCard" value="Start with a new Ad post" defaultChecked onChange={handleNewOrDraftPost} />
                                        </div>
                                        <label htmlFor='startNewCard'>
                                            Post a new ad
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="card mt-3 px-3 cursorPointer" id='useDraft' onClick={() => document.getElementById('Use Previous Ad Template').click()}>
                                <div className="card-body ">
                                    <div className='d-flex align-items-center'>
                                        <div className="form-check me-4">
                                            <input className="form-check-input yesOrNoRadioButtonColor" type="radio" name="wayToPost" id="Use Previous Ad Template" value="Use Previous Posted Ad Template" onChange={handleNewOrDraftPost} />
                                        </div>
                                        <label htmlFor='Use Previous Ad Template'>
                                            Use previously posted ad template
                                        </label>
                                    </div>
                                </div>
                            </div>


                            <div className="card mt-3 px-3 cursorPointer" id='useDraft' onClick={() => document.getElementById('draftCard').click()}>
                                <div className="card-body ">
                                    <div className='d-flex align-items-center'>
                                        <div className="form-check me-4">
                                            <input className="form-check-input yesOrNoRadioButtonColor" type="radio" name="wayToPost" id="draftCard" value="Use draft" onChange={handleNewOrDraftPost} />
                                        </div>
                                        <label htmlFor='draftCard'>
                                            Use draft
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>





                        {selectedCard ?
                            draftLoading ?
                                <div className="mt-4 border-0 card col-11 col-md-9 col-lg-8 col-sm-10 mx-auto border-0 shadow-sm rounded-4 py-4 employerHomePadding mb-3">
                                    <div className="card ">
                                        <div className="card-body px-3 py-2 ">
                                            <div className="position-relative align-items-lg-center searchJobSpace">
                                                <input
                                                    id='partnerHomeFormSearchField'
                                                    type="text"
                                                    className="form-control shadow rounded px-5 search-field ms-3"
                                                    placeholder="Search by ad title"
                                                    onChange={(e) => handleSearchGetAd(e)}
                                                />
                                                <span className='fs-5 search-icon'><IoSearchOutline /></span>

                                            </div>
                                        </div>

                                    </div>
                                    {
                                        getDraftDataDuplicates.length > 0 ?
                                            getDraftDataDuplicates.map((v, i) => {
                                                return (
                                                    <div className="card  mt-3 px-3 cursorPointer" id={`individualDraft${v.id}Card`} key={i} onClick={() => document.getElementById(i).click()}>
                                                        <div className="card-body">

                                                            <div className="row row-cols-4 row-cols-lg-6 row-cols-md-5 row-cols-sm-4 text-wrap">
                                                                <div className="col-lg-5 col-md-6 col-sm-6 col-12">
                                                                    <div className='d-flex align-items-center  mx-3'>
                                                                        <div className="form-check ">
                                                                            <input className="form-check-input yesOrNoRadioButtonColor" type="radio" name="searchByJobTitle" id={i} value={v.title} onChange={(e) => handleDraftTemplate(e, v)} />
                                                                        </div>
                                                                        <div className='text-start ms-4'>
                                                                            <label htmlFor={i} className='text-start'>
                                                                                {v.title ? v.title : null}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-0">
                                                                </div>
                                                                <div className="col-lg-5 col-md-4 col-sm-4 col-12 ms-4 ms-sm-0 d-sm-flex text-center">
                                                                    <div>
                                                                        {v.created_at ? v.created_at : null}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                )
                                            })
                                            :
                                            <div className="col-12">
                                                <h5 className='text-secondary text-center py-5 mb-0'>No template found</h5>
                                            </div>
                                    }

                                </div>



                                :
                                <div
                                    className="card mt-4 border-0 p-0 col-11 col-md-9 col-lg-8 col-sm-10 mx-auto rounded-4 overflow-hidden mb-3 placeholder-glow"
                                    aria-hidden="true"
                                >
                                    <div className="card-body p-0 mt-2">
                                        <div className="p-3 py-2">
                                            <h5 className="card-title mx-auto mb-4">
                                                <span className="placeholder col-12 py-4 rounded-3"></span>
                                            </h5>
                                            <h5 className="card-title  mx-auto mb-4">
                                                <span className="placeholder col-12 py-4 rounded-3"></span>
                                            </h5>
                                            <h5 className="card-title  mx-auto mb-4">
                                                <span className="placeholder col-12 py-4 rounded-3"></span>
                                            </h5>
                                            <h5 className="card-title  mx-auto mb-2">
                                                <span className="placeholder col-12 py-4 rounded-3"></span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            :
                            null
                        }




                        <div className="col-11 col-md-9 col-lg-8 col-sm-10 mx-auto  mt-3">
                            <div className=' text-end pb-3'>
                                <button id='partnerFormNextButton' className={jobAdStatus === 'Start with a new Ad post' || selectedTemplateCard ? 'btn btn-brand-color w-25' : 'btn btn-brand-color w-25 disabled'} onClick={handleCreateNewCard}>Next</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Second Page */}
            <div className={pageNumber === true ? "d-none" : "d-block"}>
                <div className="container-fluid community-page-bg min-vh-100 pt-4">
                    <div>
                        {!review ?
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 mx-auto">
                                <div className="col-12 col-md-9 col-lg-8 pt-3 w-100 text-center pb-3">
                                    {updateButton ?
                                        <>
                                            <h3 className='col-6 mx-auto fw-normal'>Update Ad</h3>
                                        </>

                                        :
                                        postDraftButton ?
                                            <>
                                                <h3 className='col-6 mx-auto fw-normal'>Create New Ad</h3>
                                            </>
                                            :
                                            <>
                                                <h3 className='col-6 mx-auto fw-normal'>Create New Ad</h3>

                                            </>
                                    }
                                </div>
                                <div className="card col-12 col-md-9 col-lg-8 mx-auto border-0 shadow-sm rounded-4 py-4 employerHomePadding mb-4">
                                    <form className='col-12 mx-auto'>

                                        {/* Card Title */}
                                        <div className="mb-3">
                                            <label htmlFor="jobTitle" className="form-label fs-6 fw-semibold mb-0">Title</label>
                                            <input type="text" className={partnerHomeDatas.title.length === 0 ? "form-control px-3 text-secondary" : "form-control px-3"} id="jobTitle" value={partnerHomeDatas.title === "" ? "" : partnerHomeDatas.title.slice(0, 50)} onChange={handleTitle} placeholder='Enter a title' aria-describedby="emailjobTitleHelp" />
                                        </div>

                                        <div className='mb-3'>
                                            <div className="row">
                                                <div className="col-lg-12 d-flex flex-wrap justify-content-between ">
                                                    <h6 className='fw-semibold mb-0 col-12 col-sm-6'>Description</h6>
                                                    <div className='card-date-text col-12 col-sm-6 text-sm-end'>
                                                        (min 150 char - max 600 char)
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="container">
                                                <div className="row">
                                                    <textarea
                                                        id='detailedDescription'
                                                        className={partnerHomeDatas.detailedDescription.length === 0 ? "p-3 rounded-3 form-control text-secondary" : "p-3 rounded-3 form-control"}
                                                        name="detailedDescription"
                                                        required
                                                        minLength="30"
                                                        maxLength="600"
                                                        rows={3}
                                                        placeholder="Enter a detailed description"
                                                        value={partnerHomeDatas.detailedDescription.slice(0, 600)}
                                                        onChange={handleDetailedDescription}

                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>


                                        {/* Link */}
                                        <div className="row mt-3">
                                            <div className='col'>
                                                <label htmlFor="link" className="form-label fs-6 fw-semibold pe-1">Link</label>
                                                <Tooltip id="link-toolTip" className="tooltipWidth shadow fw-bolder rounded" />
                                                <IoInformationCircleSharp data-tooltip-id="link-toolTip" place="top" data-tooltip-html={`Enter a link to be displayed </br> on the ad's 'Learn More' option.</br> When professionals click on that option,</br> it will redirect them </br>to the link that you have entered.</br> This link could be your website,</br> registration page, or interest form`} className='fs-5 informationIcon cursorPointer' />
                                            </div>
                                        </div>
                                        <div className="container ">
                                            <div className="row partner-link">
                                                <input type="text" className={partnerHomeDatas.link.length === 0 ? "form-control px-3 text-secondary" : "form-control px-3"} id="link" value={partnerHomeDatas.link} onChange={handleLink} placeholder='Enter a link' aria-describedby="emailjobTitleHelp" />
                                            </div>
                                        </div>


                                        <div className="row mt-3 w-auto">
                                            {/* Attachements */}
                                            <div className="col-lg-6">
                                                <div className='col-3 w-100'>
                                                    <label htmlFor="attachments" className="form-label fs-6 fw-semibold pe-2">Attachment</label>
                                                    <Tooltip id="pdf-toolTip" className="tooltipWidth fw-bolder shadow rounded" />
                                                    <IoInformationCircleSharp data-tooltip-id="pdf-toolTip" data-placement="top" data-tooltip-html={`Upload any brochure</br> or reading material in PDF form </br>that interested professionals</br> can download upon viewing the ad`} className='fs-5 informationIcon cursorPointer' />

                                                </div>
                                                <div className="container">
                                                    <div className="row">
                                                        {pdfData.length > 0 ? (
                                                            <div className="card-body border rounded-3 pt-4 w-100">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="p-1 col-10 col-lg-10 uploaded-resume-container d-flex align-items-center my-4">
                                                                        <div className='col-2'>
                                                                            <BsFiletypePdf className="pdf-icon me-3 fs-2" />
                                                                        </div>
                                                                        <div className='col-10 ps-2'>
                                                                            <p className="attachment-name m-0">
                                                                                {pdfData}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div id='removePdfIcon' className="col-2 col-lg-2 text-end ">
                                                                        <MdDelete
                                                                            className="delete-icon fs-4 brand-color"
                                                                            title="Delete Attachment"
                                                                            onClick={() => {
                                                                                setPdfBlob({})
                                                                                setPdfData([])
                                                                                setPdfUrlToBlob({})

                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="container border rounded-2 text-center cursorPointer" id='uploadPdfFied' {...getRootPropsPdf()}>
                                                                <input {...getInputPropsPdf()} />
                                                                {isDragActivePdf ? (
                                                                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                                                                        <div className=" rounded-4 w-100 py-5">
                                                                            <div className="fs-2">
                                                                                <LuUpload />
                                                                            </div>
                                                                            <p>Drop the files here ...</p>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <div className='text-center pt-3'>
                                                                            <LuUpload className='fs-4' />
                                                                        </div>
                                                                        <div>
                                                                            <p className='my-2 ms-2 text-center'>
                                                                                <span className='d-none d-md-inline-block d-lg-inline-block'>Drag and drop or click here to upload pdf</span><span className='d-md-none d-lg-none text-center'>Upload Pdf</span></p>
                                                                            <p className="text-secondary text-center"> (Only Pdf format is supported)</p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                                }

                                                            </div>
                                                        )
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Cover Picture */}
                                            <div className="col-lg-6">
                                                <div className='col-3 mt-md-3 mt-3 mt-lg-0 w-100'>
                                                    <label htmlFor="coverPicture" className="form-label fs-6 fw-semibold text-wrap pe-2">Cover&nbsp;Image</label>
                                                    <Tooltip id="coverPicture-toolTip" className="tooltipWidth fw-bolder shadow rounded" />
                                                    <IoInformationCircleSharp data-tooltip-id="coverPicture-toolTip" data-placement="top" data-tooltip-html={`Upload an image </br>that relates to your ad's content</br> to be shown as the cover image</br> on your ad display`} className='fs-5 informationIcon cursorPointer' />
                                                   
                                                </div>
                                                <div className="container">
                                                    <div className="row">
                                                        {imageData.length > 0 ? (
                                                            
                                                            <div className="card-body border rounded-3 pt-4 ">
                                                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                                    <div className="p-1 col-10 col-lg-10 uploaded-resume-container d-flex flex-wrap align-items-center my-4">
                                                                        <div className='col-2'>
                                                                            <BsImageFill className="pdf-icon me-3 fs-2" />
                                                                        </div>
                                                                        <div className='col-10 ps-2'>
                                                                            <p className="coverImage-name m-0 text-wrap ">
                                                                                {imageData}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div id='removeImageIcon' className="col-2 col-lg-2 h-100 text-end">
                                                                        <MdDelete
                                                                            className="upload-icon  fs-4 brand-color"
                                                                            title="Delete Cover Image"
                                                                            onClick={() => {
                                                                                setImageBlob({})
                                                                                setImageData([])
                                                                                setImageUrlToBlob({})
                                                                                setImageStatus("Y")
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="container border rounded-2 text-center cursorPointer" id='uploadImageFied' {...getRootPropsImage()}>
                                                                <input {...getInputPropsImage()} />
                                                                {isDragActiveImage ? (
                                                                    <div className="card-body d-flex align-items-center justify-content-center p-0">
                                                                        <div className="rounded-4 w-100 py-5">
                                                                            <div className="fs-2">
                                                                                <LuUpload />
                                                                            </div>
                                                                            <p>Drop the files here ...</p>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <div className='text-center pt-3'>
                                                                            <LuUpload className='fs-4' />
                                                                        </div>
                                                                        <div>
                                                                            <p className='my-2 ms-2 text-center'>
                                                                                <span className='d-none d-md-inline-block d-lg-inline-block'>Drag and drop or click here to upload image</span><span className='d-md-none d-lg-none text-center'>Upload Image</span></p>
                                                                            <p className="text-secondary text-center"> (Only Png, Jpg format is supported)</p>
                                                                        </div>
                                                                    </div>
                                                                )
                                                                }

                                                            </div>
                                                        )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </form>

                                </div>

                            </div>
                            :
                            <>
                                <div className="text-center">
                                    <h3 className='fw-normal pb-3'>Review</h3>
                                </div>
                                <div className="w-100 ">
                                    <div className="col-xl-4 col-lg-5 col-md-7 col-sm-8 col-12 mx-auto">

                                        <div
                                            className="card h-100 shadow-sm rounded-4 border-0"

                                        >
                                            <div className="p-4 pt-2">
                                                <div className='my-3'>
                                                    <img
                                                        src={imageBlob.size === undefined ? `${process.env.REACT_APP_SECOND_CAREERS_CDN}${partnerHomeDatas.image}` : URL.createObjectURL(imageBlob)}
                                                        className={"rounded-2 w-100 img-fluid learning-img-height"}
                                                        alt="Image"
                                                        data-testid="imgTesting"

                                                    />
                                                </div>

                                                <h6
                                                    className={`card-title learningTitle fw-semibold pe-3`}
                                                    data-testid="cardHeadingTestId"
                                                >
                                                    {partnerHomeDatas.title}
                                                </h6>
                                                <p
                                                    className={`partner-date-text`}
                                                >Posted on {!existingAd ? currentDateTime : createNewAd.posted_on === undefined ? createNewAd.created_at : createNewAd.posted_on}</p>


                                                <span className="card-description card-text">{partnerHomeDatas.detailedDescription.slice(0,600)}
                                                </span>

                                            </div>
                                            <div className="card-footer bg-transparent border-0">
                                                <div className="d-grid gap-4 d-flex justify-content-center mb-2 mx-1">
                                                    <div className={pdfData.length === 0 ? 'd-none' : 'w-100'}>
                                                        <a
                                                            id='partnerHomeReviewDownloadButton'
                                                            href={pdfBlob.size === undefined ? `${process.env.REACT_APP_SECOND_CAREERS_CDN}${partnerHomeDatas.pdf}` : URL.createObjectURL(pdfBlob)}
                                                            download={pdfBlob.size === undefined ? `${process.env.REACT_APP_SECOND_CAREERS_CDN}${partnerHomeDatas.pdf}` : URL.createObjectURL(pdfBlob)}
                                                            className={`btn btn-outline-secondary me-md-2 w-100`}
                                                            type="button"
                                                        >
                                                            {/* <FaDownload className="me-2" /> */}
                                                            Download
                                                        </a>
                                                    </div>
                                                    <div className='w-100'>
                                                        <a
                                                            id='partnerHomeReviewLearnMoreButton'
                                                            href={partnerHomeDatas.link !== "" ? (partnerHomeDatas.link).includes("https://") ? partnerHomeDatas.link : `https://${partnerHomeDatas.link}` : null}
                                                            target='_blank'
                                                            className={`btn btn-brand-color  me-md-2 w-100`}
                                                            type="button"
                                                        >
                                                            Learn More
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </>
                        }

                    </div>
                    {!review ?
                        <div className="col-lg-8 col-md-9 col-sm-12 col-12 mx-auto pb-3">
                            <div className='d-flex align-items-center justify-content-between'>
                                {postAdLoading ?
                                    <button className='btn btn-outline-dark w-25 ms-0 ms-3 pe-none'><span className="spinner-border spinner-border-sm text-dark" role="status"></span><span className="d-inline"> Drafting...</span></button>
                                    :
                                    <button id='partnerHomeDraftButton' className={updateButton || postDraftButton ? 'd-none' : 'btn btn-outline-dark w-25 ms-0 ms-3'} onClick={(e) => handlePostAd(e, 'Draft')}>Draft</button>
                                }
                                <button id='partnerHomeReviewButton' className={updateButton || postDraftButton ? 'btn btn-outline-dark w-100 mx-3' : 'btn btn-brand-color w-25 mx-3'} onClick={handleReviewButton}>Review</button>
                            </div>
                        </div>

                        :
                        <div className="col-xl-4 col-lg-5 col-md-7 col-sm-8 col-12 mx-auto ">
                            <div className='d-flex align-items-center justify-content-between  mt-4 pb-4'>
                                {redirectPage ?
                                    <button id='partnerHomeBackToHomeButton' className='btn btn-outline-dark w-100 mx-2' onClick={() => pageRender("/partner_dashboard/home")}>Back to Home</button>
                                    :
                                    <button id='parnerHomeBackButton' className={postAdLoading ? 'btn btn-outline-dark ms-2 disabled' : 'btn btn-outline-dark px-4 ms-2'} onClick={handleBackButton}>Back</button>
                                }
                                {!redirectPage ?
                                    updateButton ?
                                        postAdLoading ?
                                            <button className='btn btn-brand-color me-3 pe-none'><span className="spinner-border spinner-border-sm text-warning" role="status"></span><span className="d-inline"> Updating...</span></button>
                                            :
                                            <button id='partnerHomeSubmitButton' className='btn btn-brand-color  me-3' onClick={(e) => handleUpdateAd(e)}>Update</button>
                                        :
                                        postDraftButton ?
                                            postAdLoading ?
                                                // draft posting as ad
                                                <button className='btn btn-brand-color w-25 me-3 pe-none'><span className="spinner-border spinner-border-sm text-warning" role="status"></span><span className="d-inline"> Posting...</span></button>
                                                :
                                                <button id='partnerHomePostButton' className='btn btn-brand-color w-25 me-3' onClick={jobAdStatus === 'Use Previous Posted Ad Template' ? (e) => handlePostAd(e, 'opened',"adNotLeftModalButton") : (e) => handleDraftPost(e, 'opened')}>Post</button>
                                            :
                                            postAdLoading ?
                                                // actual new ad posting
                                                <button className='btn btn-brand-color w-25 me-3 pe-none'><span className="spinner-border spinner-border-sm text-warning" role="status"></span><span className="d-inline"> Posting...</span></button>
                                                :
                                                <button id='partnerHomePostButton' className='btn btn-brand-color w-25 me-3' onClick={(e) => handlePostAd(e, 'opened',"adNotLeftModalButton")}>Post</button>

                                    :
                                    null}

                            </div>
                        </div>
                    }

                </div >


                {/* ad not left Modal */}

                <button type='button' className='d-none' onClick={handleAdfNotLeftModalButton} id="adNotLeftModalButton" data-bs-toggle="modal" data-bs-target="#adNotLeftModal"></button>
                <div className="modal fade" id="adNotLeftModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog  modal-dialog-centered">
                        <div className="modal-content py-2 px-3">
                            <form >
                                <div className="modal-header border-0 bg-transparent d-flex align-items-center justify-content-center">
                                    <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
                                    <button type="button" id='adNotLeftCloseButton' className="btn-close d-none" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div className="modal-body px-3 pt-4 pb-1 w-100 text-center">
                                    <div className="col mb-3">{adNotLeft  ? adNotLeft : ""}</div>

                                </div>

                                <div className="modal-footer border-0 my-3 bg-transparent row align-items-center justify-content-between ">

                                    <button className='btn btn-brand-color' onClick={handleAdNotLeftRedirect}>Back to home</button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div >
        </>
    )
}

export default PartnerHomeAndReview